import PaymentCardsOnFile from 'shared-assets/components/PaymentSolutions/PaymentCardsOnFile';

angular
  .module('kareo.ui.shared.directives.payment-cards-on-file', [
    'react'
  ])
  .directive('paymentCardsOnFile', dcPaymentCardsOnFile);

dcPaymentCardsOnFile.$inject = ['reactDirective'];

function dcPaymentCardsOnFile(reactDirective) {
  const bindings = {
    kareoApiKey: '=',
    customerId: '=',
    practiceGuid: '=',
    patientGuid: '=',
    addressRequired: '=',
    defaultAddress: '=',
    onCardFetchedResponse: '=',
    onCancelFirstCard: '=',
    showCancel: '=',
  };

  return reactDirective(PaymentCardsOnFile, bindings, props => {
    return props;
  });
}